import { Paper, styled } from "@mui/material";

export const WidgetPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(6),
  flexGrow: 1,
  height: `calc(100% - (2*${theme.spacing(6)}))`,
}));
